@if (
  {
    headerTitle: headerTitle$ | async,
    headerBreadcrumb: headerBreadcrumb$ | async,
    initialTimeRangeName: initialTimeRangeName()
  };
  as STATE
) {
  <header
    *ngIf="headerTitle$ | async as headerTitle"
    class="page-header divide-x"
  >
    <section class="page-header__breadcrumb">
      <a [routerLink]="'/'">
        <mat-icon
          class="page-header__breadcrumb-icon"
          svgIcon="dgi-home"
          color="primary"
        ></mat-icon>
      </a>
      /
      <div>
        @for (crumb of breadcrumbs(); track crumb.url; let last = $last) {
          @if (!last) {
            <a [routerLink]="crumb.url">{{ crumb.label }}</a> /
          } @else {
            <span>{{ crumb.label }}</span>
          }
        }
      </div>
    </section>

    @if (enableDateRangeFilter()) {
      <date-range-filter
        #dateRangeFilter
        [initialTimeRangeName]="STATE.initialTimeRangeName"
        (dateTimeRangeChange)="
          setDateTimeRange($event, dateRangeFilter.selectedTimeRangeName())
        "
        matTooltip="Sélectionnez la période appliquée aux indicateurs et graphiques"
        matTooltipPosition="above"
      ></date-range-filter>
    }
  </header>
}
